(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-hulkapps-backup"]) return;
  try {
    
  window.addEventListener('load', () => {
    const quantity = document.querySelector('#quantity [name=quantity]');
    const plusIcon = document.querySelector('.fa-plus');
    const minusIcon = document.querySelector('.fa-minus');

    plusIcon.addEventListener('click', () => {
      quantity.value++;
    });
    minusIcon.addEventListener('click', () => {
      if (quantity.value >= 2) quantity.value--;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  (() => {
    async function changeLineItem(lineKey, quantity) {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({
          id: lineKey,
          quantity: quantity,
        }),
      });

      if (!res.ok) throw new Error('Cart change failed');
      return await res.json(); // cart object
    }

    function formatMoneyFromTheme(cents) {
      // Einfacher Fallback (CHF). Wenn du ein Theme money-format hast, kann man das noch sauberer machen.
      try {
        return (cents / 100).toLocaleString('de-CH', { style: 'currency', currency: 'CHF' });
      } catch {
        return `${(cents / 100).toFixed(2)}`;
      }
    }

    function bindCartQtyControls() {
      document.querySelectorAll('.cart-item[data-line-key]').forEach((row) => {
        const key = row.getAttribute('data-line-key');
        const input = row.querySelector('[data-qty-input]');
        const plus = row.querySelector('[data-plus]');
        const minus = row.querySelector('[data-minus]');
        const remove = row.querySelector('[data-remove]');

        if (!key || !input || !plus || !minus) return;

        let isBusy = false;

        const setBusy = (busy) => {
          isBusy = busy;
          row.classList.toggle('is-loading', busy);
          input.disabled = busy;
          plus.style.pointerEvents = busy ? 'none' : '';
          minus.style.pointerEvents = busy ? 'none' : '';
        };

        const update = async (nextQty) => {
          nextQty = Math.max(0, parseInt(nextQty, 10) || 0);

          setBusy(true);
          try {
            const cart = await changeLineItem(key, nextQty);

            // Wenn qty auf 0 gesetzt wurde, Zeile entfernen
            if (nextQty === 0) {
              row.remove();
            } else {
              input.value = nextQty;
            }

            // Optional: Cart total updaten (wenn vorhanden)
            const totalEl = document.querySelector('[data-cart-total]');
            if (totalEl) totalEl.textContent = formatMoneyFromTheme(cart.total_price);

            // Optional: Line totals updaten (wenn du sie ausgeben willst)
            // Da /cart/change.js kein HTML liefert, muesstest du anhand cart.items das passende Item finden:
            const lineItem = cart.items.find((i) => i.key === key);
            const lineTotalEl = row.querySelector('[data-line-total]');
            if (lineItem && lineTotalEl) {
              lineTotalEl.textContent = formatMoneyFromTheme(lineItem.final_line_price);
            }
          } catch (e) {
            // Fehlerfall: Quantity wieder auf alten Wert? (hier minimal)
            console.error(e);
          } finally {
            setBusy(false);
          }
        };

        plus.addEventListener('click', () => {
          if (isBusy) return;
          update((parseInt(input.value, 10) || 0) + 1);
        });

        minus.addEventListener('click', () => {
          if (isBusy) return;
          const current = parseInt(input.value, 10) || 0;
          if (current <= 1) return;
          update(current - 1);
        });

        input.addEventListener('change', () => {
          if (isBusy) return;
          update(input.value);
        });

        if (remove) {
          remove.addEventListener('click', (e) => {
            // Entfernen ohne Seitenreload
            e.preventDefault();
            if (isBusy) return;
            update(0);
          });
        }
      });
    }

    window.addEventListener('load', bindCartQtyControls);

    function initCartCheckout() {
  const form = document.querySelector('#cart');
  const agbCheckbox = document.querySelector('#agb-check');
  const checkoutTriggerSelector = 'button[name="checkout"], input[name="checkout"], a[href="/checkout"], a[href*="/checkout"]';
  const noteInput = document.querySelector('#Cart-note');
  const noteAttributeInput = document.querySelector('#Cart-note-attribute');
  const deliveryDateInput = document.querySelector('#Cart-delivery-date');

  if (!form) return;
  if (form.dataset.cartCustomFieldsInitialized === 'true') return;
  form.dataset.cartCustomFieldsInitialized = 'true';

  let isCheckingOut = false;
  let autosaveTimeout;

  function syncCheckoutState() {
    if (!agbCheckbox) return;
    const checkoutTriggers = document.querySelectorAll(checkoutTriggerSelector);

    if (agbCheckbox.checked) {
      checkoutTriggers.forEach((checkoutTrigger) => {
        checkoutTrigger.classList.remove('is-disabled');
        checkoutTrigger.removeAttribute('aria-disabled');
      });
    } else {
      checkoutTriggers.forEach((checkoutTrigger) => {
        checkoutTrigger.classList.add('is-disabled');
        checkoutTrigger.setAttribute('aria-disabled', 'true');
      });
    }
  }

  function setCheckoutBusy(isBusy) {
    document.querySelectorAll(checkoutTriggerSelector).forEach((checkoutTrigger) => {
      if ('disabled' in checkoutTrigger) {
        checkoutTrigger.disabled = isBusy;
      }
      checkoutTrigger.setAttribute('aria-busy', isBusy ? 'true' : 'false');
    });
  }

  function syncNoteHiddenInput() {
    if (noteInput && noteAttributeInput) {
      noteAttributeInput.value = noteInput.value;
    }
  }

  function scheduleCartCustomFieldsSave() {
    clearTimeout(autosaveTimeout);
    autosaveTimeout = setTimeout(() => {
      saveCartCustomFields().catch((error) => {
        console.error(error);
      });
    }, 500);
  }

  async function saveCartCustomFields() {
    clearTimeout(autosaveTimeout);
    syncNoteHiddenInput();

    const noteValue = noteInput ? noteInput.value : '';
    const deliveryDateValue = deliveryDateInput ? deliveryDateInput.value : '';
    const body = new URLSearchParams();
    body.set('note', noteValue);
    body.set('attributes[Bestellbemerkung]', noteValue);
    body.set('attributes[Gewünschter Liefertermin]', deliveryDateValue);

    const res = await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        Accept: 'application/json',
      },
      body: body.toString(),
    });

    if (!res.ok) throw new Error('Cart custom fields could not be saved');

    const cart = await res.json();
    const savedNoteAttribute = cart.attributes && cart.attributes['Bestellbemerkung'];
    const savedDate = cart.attributes && cart.attributes['Gewünschter Liefertermin'];

    if ((noteValue && cart.note !== noteValue && savedNoteAttribute !== noteValue) || (deliveryDateValue && savedDate !== deliveryDateValue)) {
      throw new Error('Cart custom fields were not persisted');
    }

    return cart;
  }

  async function handleCheckout(event) {
    event.preventDefault();
    event.stopPropagation();

    if (agbCheckbox && !agbCheckbox.checked) {
      agbCheckbox.reportValidity();
      agbCheckbox.focus();
      return;
    }

    if (isCheckingOut) return;
    isCheckingOut = true;
    setCheckoutBusy(true);

    try {
      await saveCartCustomFields();
      window.location.assign('/checkout');
    } catch (error) {
      console.error(error);
      isCheckingOut = false;
      setCheckoutBusy(false);
      alert('Bestellbemerkung und Liefertermin konnten nicht gespeichert werden. Bitte versuche es erneut.');
    }
  }

  if (noteInput) {
    noteInput.addEventListener('input', syncNoteHiddenInput);
    noteInput.addEventListener('input', scheduleCartCustomFieldsSave);
    noteInput.addEventListener('change', scheduleCartCustomFieldsSave);
    syncNoteHiddenInput();
  }

  if (deliveryDateInput) {
    deliveryDateInput.addEventListener('change', scheduleCartCustomFieldsSave);
  }

  if (agbCheckbox) {
    agbCheckbox.addEventListener('change', syncCheckoutState);
  }

  document.addEventListener('click', (event) => {
    const checkoutTrigger = event.target.closest(checkoutTriggerSelector);

    if (checkoutTrigger) {
      handleCheckout(event);
    }
  }, true);

  form.addEventListener('submit', handleCheckout, true);

  syncCheckoutState();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCartCheckout);
} else {
  initCartCheckout();
}

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const wrapper = document.querySelector('[data-search-wrapper]');
    if (!wrapper) return;

    const toggle = wrapper.querySelector('[data-search-toggle]');
    const form = wrapper.querySelector('[data-search-form]');
    const input = wrapper.querySelector('[data-search-input]');

    if (!toggle || !form || !input) return;

    function openSearch() {
      wrapper.classList.add('search-open');
      toggle.setAttribute('aria-expanded', 'true');

      requestAnimationFrame(function () {
        input.focus();
        if (input.value.length) {
          input.setSelectionRange(input.value.length, input.value.length);
        }
      });
    }

    function closeSearch() {
      wrapper.classList.remove('search-open');
      toggle.setAttribute('aria-expanded', 'false');
      input.blur();
    }

    toggle.addEventListener('click', function (event) {
      event.stopPropagation();

      if (wrapper.classList.contains('search-open')) {
        closeSearch();
      } else {
        openSearch();
      }
    });

    form.addEventListener('click', function (event) {
      event.stopPropagation();
    });

    document.addEventListener('click', function (event) {
      if (!wrapper.contains(event.target)) {
        closeSearch();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        closeSearch();
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  window.addEventListener('load', () => {
    var quantity = document.querySelector('.quantity [name="quantity"]');
    var plusIcon = document.querySelector('.fa-plus');
    var minusIcon = document.querySelector('.fa-minus');

    if (quantity && plusIcon && minusIcon) {
      plusIcon.addEventListener('click', function () {
        quantity.value = parseInt(quantity.value, 10) + 1;
      });

      minusIcon.addEventListener('click', function () {
        var current = parseInt(quantity.value, 10) || 1;
        if (current >= 2) {
          quantity.value = current - 1;
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
